export default __webpack_public_path__ + "static/e7b44095424b4b3c7472ca831722365d.png";